module.exports = __webpack_public_path__ + "static/media/object.ac73800e.gif";